// extracted by mini-css-extract-plugin
module.exports = {"previewData":"ResultPreview_previewData__38kkg","linkButton":"ResultPreview_linkButton__2Pmbw"};